import React, {useEffect, useState} from 'react';
import {getRecentMatches} from "../../services/matches";
import {useAuth} from "../../contexts/authContext";
import Tabs from "react-simply-tabs";
import {Col, Row} from "react-bootstrap";
import {getUnconcludedPaidRegistrations, getUnconcludedUnpaidRegistrations} from "../../services/registrations";
import NoRegistrationsAlert from "../../components/NoRegistrationsAlert";
import {useSwipeableHook} from "../../utils";
import {sendFirebaseToken} from "../../services/users";
import {useTranslation} from "react-i18next";

// React Components
import Header from "../../components/Header";
import GameCard from "../../components/GameCard";

// CSS Files
import './styles.css';

const Schedule = (props) => {
   const [unconcludedRegistrations, setUnconcludedRegistrations] = useState([]);
   const [recentMatches, setRecentMatches] = useState([]);
   const [loading, setLoading] = useState(true);
   const {user} = useAuth();
   const {handlers, activeTabIndex, setActiveTabIndex} = useSwipeableHook(recentMatches.schedule?.length);
   const { t } = useTranslation();

   useEffect(() => {
      (async () => {
         if (window.location.href.includes('firebase_token')) {
            await sendFirebaseToken(window.location.href.split('?')[1].split('=')[1]);
         }

         let unconcludedPaidRegistrations = await getUnconcludedPaidRegistrations();
         let unconcludedUnpaidRegistrations = await getUnconcludedUnpaidRegistrations();
         let recentMatches = await getRecentMatches(
            user.active_enrollment?.league_edition_id,
            user.active_enrollment?.league_id,
            user.active_enrollment?.league_category_id,
            user.active_enrollment?.league_division_id
         );

         setUnconcludedRegistrations(unconcludedPaidRegistrations.concat(unconcludedUnpaidRegistrations));
         setRecentMatches(recentMatches);
         setLoading(false);
      })();
   }, [user.active_enrollment]);

   if (!recentMatches)
      return null;

   const generateTabs = () => {
      return recentMatches.schedule?.map((tab, key) => {
         let isWeekEmpty = Object.keys(tab)
         .filter(key => key !== "tab_name")
         .every(matchArray => Array.isArray(tab[matchArray]) && tab[matchArray].length === 0);

         return <div key={key} className="inner-tab-container">
            <span className="inner-tab-subtitle">{tab.tab_name}</span>

            <div className="games-tab-content">
               {tab.scheduled_matches.map((game, key) => {
                  return <GameCard key={key} gameInfo={game} streakText={game.state === "scheduled" ? t("schedule_page.scheduled") : t("schedule_page.played")} streakColor={"green"}/>
               })}

               {tab.scheduled_matches.length === 0 && !isWeekEmpty &&
                  <div className={"d-flex justify-content-center align-items-center mt-5 mb-5 no-matches-text text-uppercase"}>
                     {t("schedule_page.no_schedule_matches")}
                  </div>
               }

               {tab.to_schedule_gameweek_match.length !== 0 &&
                  <GameCard gameInfo={tab.to_schedule_gameweek_match} streakText={t("schedule_page.to_schedule")} streakColor={"red"}/>
               }

               {tab.oldest_match.length !== 0 &&
                  <GameCard gameInfo={tab.oldest_match} streakText={t("schedule_page.adjust_schedule")}/>
               }

               {tab.future_weeks_match.length !== 0 &&
                  <GameCard gameInfo={tab.future_weeks_match} streakText={t("schedule_page.schedule_ahead")}/>
               }

               {isWeekEmpty &&
                  <div className={"d-flex justify-content-center align-items-center mt-5 mb-5 no-matches-text text-uppercase"}>
                     {t("common.all_done")}
                  </div>
               }
            </div>
         </div>
      })
   };

   return <div className={"Schedule"}>
      <Header
         headerBarTitle={t("schedule_page.header")}
         class={"mb-0"}
         showHeaderExtras>
      </Header>

      {!user.active_enrollment && unconcludedRegistrations.length === 0 &&
         <NoRegistrationsAlert
            text={t("common.no_registrations")}
         />
      }

      {recentMatches.schedule?.length === 0 &&
         <Row>
            <Col xs={{span: 10, offset: 1}}>
               <div className="alert alert-info mt-4" role="alert">
                  {recentMatches.message}
               </div>
            </Col>
         </Row>
      }

      {recentMatches.schedule?.length !== 0 && user.active_enrollment && !loading &&
         <div className={"flex-grow-1"} {...handlers}>
            <Tabs
               activeTabIndex={activeTabIndex}
               onRequestChange={setActiveTabIndex}
               wrapperProps={{
                  className: "tabs-container"
               }}
               controlsWrapperProps={{
                  className: "tab-controls-container"
               }}
               activeControlProps={{
                  className: "tab-control-active"
               }}
               controls={recentMatches.schedule?.map(tab => <button type="button" className="btn-tab-control">{tab.tab_name}</button>)}
            >
               {generateTabs()}
            </Tabs>

            <div className="full-games-container">
               {generateTabs()}
            </div>
         </div>
      }
   </div>
}

export default Schedule;